import { useState } from 'react';
import React from 'react';

import { CheckoutStepsContext } from './CheckoutStepsContext.ts';

export function CheckoutSteps({ children }: React.PropsWithChildren) {
  const [step, setStep] = useState(0);

  const prevStep = () => setStep((x) => x - 1);
  const nextStep = () => setStep((x) => x + 1);

  return (
    <CheckoutStepsContext.Provider value={{ step, prevStep, nextStep }}>
      {children}
    </CheckoutStepsContext.Provider>
  );
}
